"use client";
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import React from "react";
import Carousel from "react-grid-carousel";
const ImageSlider = ({ content, path }) => {
    return (
        <div className="grid place-items-center mx-10 my-16 md:my-[140px] px-4 md:px-24 lg:px-24 xl:px-0">
            <Carousel
                cols={4}
                rows={1}
                gap={10}
                loop
                autoplay={3000}
                hideArrow={content.length > 4 ? false : true}
            >
                {content?.map((item) => {
                    return (
                        <Carousel.Item key={item?.id}>
                            <img
                                src={`/assets/${path}/${item?.image}.png`}
                                alt={item?.alt}
                            />
                        </Carousel.Item>
                    );
                })}
            </Carousel>
        </div>
    );
};

export default ImageSlider;
